'use client'

import type React from 'react'

export default function PrivacyPolicy() {
  const handleContactPress = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.open('mailto:info@rtsc.live', '_blank')
  }

  return (
    <div className='bg-white rounded-md m-4 p-6 shadow-sm overflow-y-auto max-w-5xl mx-auto'>
      {/* Title */}
      <h1 className='text-4xl font-bold mb-6'>Privacy Policy</h1>

      {/* Introduction */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Introduction</h2>
        <p className='mb-2'>
          Our privacy policy will help you understand what information we collect at RTSC, how RTSC uses it, and what
          choices you have. RTSC built the "RTSC" app as a free app. This SERVICE is provided by RTSC at no cost and is
          intended for use as is.
        </p>
        <p className='mb-2'>
          If you choose to use our Service, then you agree to the collection and use of information in relation with
          this policy. The personal information that we collect is used for providing and improving the Service. We will
          not use or share your information with anyone except as described in this Privacy Policy.
        </p>
        <p>
          The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are
          accessible on our website, unless otherwise defined in this Privacy Policy.
        </p>
      </div>

      {/* Information Collection */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Information Collection</h2>
        <p className='mb-2'>
          For a better user experience while using our Service, we may require you to provide certain personally
          identifiable information, including but not limited to your name, email address, and profile picture. The
          information we request will be retained and used as described in this Privacy Policy.
        </p>
        <p>The app uses third-party services that may collect information used to identify you.</p>
      </div>

      {/* Cookies */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Cookies</h2>
        <p className='mb-2'>
          Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These
          are sent to your browser from the website you visit and are stored on your device's internal memory.
        </p>
        <p>
          This service does not explicitly use cookies. However, the app may include third-party code and libraries that
          use cookies to collect information and improve their services. You have the option to accept or refuse these
          cookies and to know when a cookie is being sent to your device. If you refuse our cookies, you may not be able
          to use some portions of the Service.
        </p>
      </div>

      {/* Location Information */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Location Information</h2>
        <p>
          Some of the services may use location information transmitted from users' mobile devices. We use this
          information only within the scope necessary for the designated service.
        </p>
      </div>

      {/* Device Information */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Device Information</h2>
        <p>
          We collect certain information from your device to provide better service and prevent fraudulent acts. This
          information does not include data that could directly identify you as an individual user.
        </p>
      </div>

      {/* Service Providers */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Service Providers</h2>
        <p className='mb-2'>We may employ third-party companies and individuals for the following reasons:</p>
        <ul className='pl-4 mb-2 list-disc list-inside'>
          <li className='text-base'>To facilitate our Service</li>
          <li className='text-base'>To provide the Service on our behalf</li>
          <li className='text-base'>To perform Service-related tasks</li>
          <li className='text-base'>To assist us in analyzing how our Service is used</li>
        </ul>
        <p>
          These third parties have access to your personal information only to perform the tasks assigned to them on our
          behalf and are obligated not to disclose or use it for any other purpose.
        </p>
      </div>

      {/* Security */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Security</h2>
        <p>
          We value your trust in providing us with your personal information and strive to use commercially acceptable
          means to protect it. However, no method of transmission over the internet or electronic storage is 100% secure
          and we cannot guarantee absolute security.
        </p>
      </div>

      {/* Children's Privacy */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Children's Privacy</h2>
        <p>
          This service does not address anyone under the age of 13. We do not knowingly collect personally identifiable
          information from children under 13. If we become aware that a child under 13 has provided us with personal
          information, we will delete it from our servers. If you are a parent or guardian and believe your child has
          provided us with personal information, please contact us so that we can take the necessary actions.
        </p>
      </div>

      {/* Changes to This Policy */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. You are advised to review this page periodically for any
          changes. We will notify you of changes by posting the new Privacy Policy on this page; changes become
          effective immediately upon posting.
        </p>
      </div>

      {/* Contact Us */}
      <div className='mb-6'>
        <h2 className='text-3xl font-semibold mb-2 border-b border-gray-200 pb-1'>Contact Us</h2>
        <p>
          If you have any questions or suggestions about our Privacy Policy, please contact us at{' '}
          <a href='mailto:info@rtsc.live' onClick={handleContactPress} className='text-blue-600 underline'>
            info@rtsc.live
          </a>
          .
        </p>
      </div>
    </div>
  )
}
